import React, {Component} from 'react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import DateUtilities from '../../componentes/DateUtilities'
import { Dropdown, Input} from 'semantic-ui-react'
import Single from '../../componentes/Single'
import moment from 'moment'
import WeekPayment from '../../componentes/WeekPayment/WeekPayment'
import EpicMenu from '../../componentes/Menus/EpicMenu';

export default class PagosAdmin extends Component{
    constructor(props){
        super(props)
        this.state={
            pagos:[],
            status:'unpaid',
            dateFilter:'pastWeek',
            firstDate:'',
            firstDateStr:'',
            secondDate:'',
            secondDateStr:'',
            employee:'Todos',
        }
        this.unsubscribe=null
    }
    setReference=()=>{
        let dbReference=firebase.firestore().collection('Pagos')
        dbReference=this.filterByEmployee(dbReference)
        dbReference=this.filterByDate(dbReference)
        dbReference=this.filterByStatus(dbReference)
        return dbReference
    }
    filterByDate=(dbReference)=>{
        if(this.state.dateFilter==='thisWeek'){
            return this.filterThisWeek(dbReference)
        }
        if(this.state.dateFilter==='pastWeek'){
            return this.filterPastWeek(dbReference)
        }
        if(this.state.dateFilter==='specificDateRange'){
            if(this.state.firstDate!=='' && this.state.secondDate!==''){
                return this.filterSpecificDates(dbReference)
            }
        }
        if(this.state.dateFilter==='thisMonth'){
            return this.filterThisMonth(dbReference)
        }
        if(this.state.dateFilter==='thisYear'){
            return this.filterThisYear(dbReference)
        }
        return dbReference
    }
    filterThisWeek=dbReference=>{
        const thursday=DateUtilities.getThursdayDate(DateUtilities.today())
        return dbReference.where('fecha', '>=', thursday)
    }
    filterPastWeek=dbReference=>{
        const thisThursday=DateUtilities.getThursdayDate(DateUtilities.today())
        const lastThursday=DateUtilities.addDays(thisThursday, -7)
        return dbReference.where('fecha', '>=', lastThursday).where('fecha', '<', thisThursday)
    }
    filterThisMonth=(dbReference)=>{
        const firstOfMonth=DateUtilities.getFirstDayOfMonth()
        return dbReference.where('fecha', '>=', firstOfMonth)
    }
    filterThisYear=dbReference=>{
        const firstOfYear=DateUtilities.getFirstDayOfYear()
        return dbReference.where('fecha', '>=', firstOfYear)
    }
    filterSpecificDates=dbReference=>{
        return dbReference.where('fecha', '>=', this.state.firstDate).where('fecha', '<', DateUtilities.addDays(this.state.secondDate, 1))
    }
    filterByStatus=dbReference=>{
        if(this.state.status==='unpaid')
            return dbReference.where('estado', '==', 'pendiente')
        if(this.state.status==='paid')
            return dbReference.where('estado', '==', 'completado')
        return dbReference
    }
    filterByEmployee=dbReference=>{
        if (this.state.employee === "Todos"){return dbReference}
        return dbReference.where('empleado', '==', this.state.employee)   
    }
    getFirstAndLastWeeks=()=>{
        if(this.state.dateFilter==='thisWeek'){
            return {first:moment().week(), last:moment().week()}
        }
        if(this.state.dateFilter==='pastWeek'){
            const thisThursday=DateUtilities.getThursdayDate(DateUtilities.today())
            const lastThursday=DateUtilities.addDays(thisThursday, -7)
            return {first:moment(lastThursday).week(), last:moment(thisThursday).week()}
        }
        if(this.state.dateFilter==='thisMonth'){
            return {first:moment(DateUtilities.getFirstDayOfMonth).week(), last:moment().week()}
        }
    }
    getWeekAndYear=(date)=>{
        let momentDate=moment(date)
        let dayOfTheWeek=momentDate.day()
        let year=momentDate.year()
        let week=dayOfTheWeek>=4 
            ? moment(DateUtilities.addDays(date, 3)).week()
            : momentDate.week() 
        return`${week} ${year}`
    }
    GetData=()=>{
		this.unsubscribe=this.setReference().orderBy('fecha').onSnapshot(pagos=>{
            try{
                const pagosArray=[]
                let weekIndex=-1
                let empleadosIndexMap={}
                for(let i=0; i<pagos.size;i++){
                    const pago=pagos.docs[i]
                    const date=pagos.docs[i].data().fecha.toDate()
                    const weekAndYear=this.getWeekAndYear(date)
                    if(pagosArray.length===0 || pagosArray[weekIndex].weekAndYear!==weekAndYear){
                        pagosArray.push({weekAndYear:weekAndYear, employees:[], total:0})
                        weekIndex++
                        empleadosIndexMap={}
                    }
                    const employee=pago.data().empleado
                    if(empleadosIndexMap[employee]===undefined){
                        pagosArray[weekIndex].employees.push({
                            employee:employee,
                            salary:0,
                            activities:[],
                            horas:[],
                            harvestFrambuesa:[],
                            harvestZarzamora:[],
                        })
                        empleadosIndexMap[employee]=pagosArray[weekIndex].employees.length-1   
                    }
                    pagosArray[weekIndex].employees[empleadosIndexMap[employee]].salary+=pago.data().precio
                    pagosArray[weekIndex].total+=pago.data().precio

                    if(pago.data().nombreActividad==='Piscar Zarzamora'){
                        pagosArray[weekIndex].employees[empleadosIndexMap[employee]].harvestZarzamora.push({
                            id:pago.id,
                            actividad:pago.data().nombreActividad,
                            areaHecha:pago.data().areaHecha,
                            fecha:pago.data().fecha.toDate().toLocaleDateString(),
                            estado:pago.data().estado,
                            precio:pago.data().precio,
                            cajas6Precio:pago.data().cajas6Precio,
                            dificultad:pago.data().dificultad,
                            totalCajas:pago.data().totalCajas,
                        })
                    }else if(pago.data().nombreActividad==='Piscar Frambuesa'){
                            pagosArray[weekIndex].employees[empleadosIndexMap[employee]].harvestFrambuesa.push({
                                id:pago.id,
                                actividad:pago.data().nombreActividad,
                                areaHecha:pago.data().areaHecha,
                                fecha:pago.data().fecha.toDate().toLocaleDateString(),
                                estado:pago.data().estado,
                                precio:pago.data().precio,
                                cajas6Precio:pago.data().precio / pago.data().trabajoHecho,
                                dificultad:pago.data().dificultad,
                                trabajoHecho:pago.data().trabajoHecho,
                            })
                    }else if(pago.data().nombreActividad==='sueldo por horas'){
                            pagosArray[weekIndex].employees[empleadosIndexMap[employee]].horas.push({
                                id:pago.id,
                                actividad:pago.data().nombreActividad,
                                fecha:pago.data().fecha.toDate().toLocaleDateString(),
                                estado:pago.data().estado,
                                puesto1:pago.data().puesto1,
                                horas1:pago.data().horas1,
                                puesto2:pago.data().puesto2,
                                horas2:pago.data().horas2,
                                puestoE:pago.data().puestoE,
                                horasE:pago.data().horasE,
                                precio:pago.data().precio,
                            })
                    }else{
                        pagosArray[weekIndex].employees[empleadosIndexMap[employee]].activities.push({
                            id:pago.id,
                            actividad:pago.data().nombreActividad,
                            areaHecha:pago.data().areaHecha,
                            trabajoHecho:pago.data().trabajoHecho,
                            fecha:pago.data().fecha.toDate().toLocaleDateString(),
                            estado:pago.data().estado,
                            unidades:pago.data().unidades,
                            numInvolucrados:pago.data().numInvolucrados,
                            precio:pago.data().precio,
                            dificultad:pago.data().dificultad,
                        })
                    }
                }
                this.setState({
                    pagos:pagosArray
                })
            }
            catch(e){
                console.log(e)
            }
        })
    }
    handleDateFilterChange=(e, {value})=>{
        this.setState({dateFilter:value})
    }
    handleEmployeeChange=(e, {value})=>{
        this.setState({employee:value})
    }
    handleStatusChange=(e, {value})=>{
        this.setState({status:value})
    }
    handleSpecificDateChange=(e, {name, value})=>{
        const date=DateUtilities.parseDate(value)
        this.setState({
            [name]:date,
            [name+'Str']:value
        })
    }
    componentDidMount(){
        this.GetData()
    }
    componentDidUpdate(prevProps, prevState){
        let filtersHaveChanged=false
        if(this.state.dateFilter!==prevState.dateFilter && this.state.dateFilter!=='specificDateRange'){
            filtersHaveChanged=true
        }
        if(this.state.employee!==prevState.employee)
            filtersHaveChanged=true
        if(this.state.status!==prevState.status){
            filtersHaveChanged=true
        }
        if(this.state.firstDate!== prevState.firstDate && this.state.secondDate!=='')
            filtersHaveChanged=true
        if(this.state.secondDate!==prevState.secondDate && this.firstDate!=='')
            filtersHaveChanged=true
        if(filtersHaveChanged){
            this.unsubscribe()
            this.GetData()
        }
    }
    render(){
        return(
            <section>
            <div className='header'>
				<EpicMenu />
				<div className='inline'>Pagar Sueldos</div>
			</div>
            <div className='body'>
                <div className="filtros">
                    <div >
                        <Dropdown
                            fluid
                            selection
                            options={[
                                {key:1, text:'Esta semana', value:'thisWeek'},
                                {key:2, text:'Semana pasada', value:'pastWeek'},
                                {key:3, text:'Este mes', value:'thisMonth'},
                                {key:4, text:'Este año', value:'thisYear'},
                                {key:5, text:'Fechas específicas', value:'specificDateRange'},
                            ]}
                            name='dateFilter'
                            value={this.state.dateFilter}
                            onChange={this.handleDateFilterChange}
                        />
                    </div>
                    <div >
                        <Single 
                            tabla='Empleados' 
                            columna='Nombre'
                            placeholder='Empleados'
                            incluir={["Todos"]}
                            value={this.state.employee} 
                            onChange={this.handleEmployeeChange} 
                            all={1} 
                        />
                    </div>
                    <div>
                        <Dropdown
                            fluid
                            selection
                            options={[
                                {key:1, value:'unpaid', text:'Pendientes'},
                                {key:2, value:'paid', text:'Completados'},
                                {key:3, value:'all', text:'Todos'}
                            ]}
                            value={this.state.status}
                            onChange={this.handleStatusChange}
                        />
                    </div>
                    {
                        this.state.dateFilter==='specificDateRange'
                         ?
                        <>
                        <div>
                            <h3>Del</h3>
                            <Input
                                type='date'
                                value={this.state.firstDateStr}
                                name='firstDate'
                                onChange={this.handleSpecificDateChange}
                            />
                        </div>
                        <div>
                            <h3>Al</h3>
                            <Input
                                type='date'
                                value={this.state.secondDateStr}
                                name='secondDate'
                                onChange={this.handleSpecificDateChange}
                            />
                        </div>
                        </>
                        :null
                    }
                </div>
                {
                    this.state.pagos.map((week, i)=>{
                        return <WeekPayment key={i} week={week} status={this.state.status}/>
                    })
                }
            </div>
            <div className="footer" >
                <div className="footer1" >
                </div>
                <div className="footer2" ></div>
			</div>
            </section>
        )
    }
}